export default "__VITE_ASSET__BgaS2rbI__"